import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Button } from "@nutrayan/ui";
import { useAuth } from "@/lib/auth";

const NAV = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/catalog", label: "Catalog" },
  { to: "/orders", label: "Orders" },
  { to: "/customers", label: "Customers" },
  { to: "/inventory", label: "Inventory" },
  { to: "/analytics", label: "Analytics" },
];

export function Shell() {
  const auth = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    auth.clear();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen">
      <aside className="border-charcoal/10 bg-sand w-56 shrink-0 border-r p-4">
        <p className="font-display text-display-sm text-charcoal">Nutrayan</p>
        <p className="text-caption text-muted">Admin</p>
        <nav className="mt-6 flex flex-col gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-body-sm rounded px-3 py-2 ${
                  isActive ? "bg-cream text-saffron" : "text-charcoal hover:bg-cream"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex flex-1 flex-col">
        <header className="border-charcoal/10 bg-cream flex items-center justify-between border-b px-6 py-3">
          <div>
            <p className="text-caption text-muted">Signed in</p>
            <p className="text-body-sm text-charcoal">{auth.email ?? "—"}</p>
          </div>
          <Button size="sm" variant="ghost" onClick={onLogout}>
            Sign out
          </Button>
        </header>
        <main className="bg-cream flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
